import { useTranslation } from "react-i18next";
import React, { useRef, useState } from "react";
import { Link } from "react-router-dom";
import CartSvg from "../assets/icons/cart.svg";
import Cart from "../assets/icons/cart.jsx";
import { useDeviceSize } from 'react-device-sizes'


function CartButton({ items, price, local, isActive, openFromMobileMenu /* this is a dumb solution to fix font size of cart on the mobile panel */ }) {
    const {
        //(min-width: 768px)
        mdDown, //(max-width: 991.98px)
        //(min-width: 1200px)
    } = useDeviceSize();
    const { t } = useTranslation();
    const total = useRef(0);
    const [isHovered, setIsHovered] = useState(false);

    return (
        <Link
            to="/cart"
            className={`flex items-center gap-2 relative navbar-link ${isActive && 'active text-white lg:text-black'}`}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
        >
            <>
                <div className={`${openFromMobileMenu ? 'text-lg' : 'text-sm xl:text-lg'}`}>
                    {t('navbar.cart')}
                </div>
                <div className="relative w-8">
                    <Cart color={isActive && mdDown ? "#FFFFFF" : "#003a80"} />
                    <div
                        className={`absolute w-4 h-4 text-xs text-white bg-secondary-color rounded-full top-0 right-0 flex justify-center items-center transform translate-x-2 -translate-y-2`}>
                        {items}
                    </div>
                </div>
            </>
            {isHovered && (
                <p className="text-base text-center absolute -bottom-full -left-6 z-10 bg-white mt-4 py-2 px-2 w-36">
                    {local === "fr" ? `${price}.00 Da` : `${price}.00 دج`}
                </p>
            )}
        </Link>
    );
}

export default CartButton;
